import { createIdentifier } from '@wendellhu/redi';
import type { CaseMaindataDTO } from '@holoview/dao-gen/generated';
import type {
  CaseAppendsQueryParams,
  CaseLibraryQueryParams,
  CaseListPageDto,
  CaseListQueryParams,
  CaseMaindataArchiveCreateParams,
  CaseMainDataParams,
  CaseShowcaseQueryParams,
} from '../dto/case.dto';

export interface ICaseRepository {
  findAll(filter: CaseListQueryParams): Promise<CaseListPageDto<CaseMaindataDTO>>;
  searchLibraryCases(params: CaseLibraryQueryParams): Promise<CaseListPageDto<Record<string, unknown>>>;
  findById(id: number): Promise<CaseMaindataDTO | null>;
  findEditableCase(id: number): Promise<Record<string, unknown> | null>;
  createMainData(params: CaseMainDataParams): Promise<CaseMaindataDTO>;
  updateMainData(id: number, params: CaseMainDataParams): Promise<void>;
  createArchive(caseId: number, params: CaseMaindataArchiveCreateParams): Promise<void>;
  updateArchive(caseId: number, params: CaseMaindataArchiveCreateParams): Promise<void>;
  updateStatus(id: number, status: string): Promise<void>;
  searchWithAppends(params: CaseAppendsQueryParams): Promise<CaseMaindataDTO[]>;
  getShowcaseCaseCards(params: CaseShowcaseQueryParams): Promise<Record<string, unknown>[]>;
  findCasesWithArchiveByIds(ids: number[]): Promise<Record<string, unknown>[]>;
}

export const ICaseRepository = createIdentifier<ICaseRepository>('backend.case.repository');
